export const planImages = [
    "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fbanner_image%2F1.jpg?alt=media&token=654fc08a-462e-43bf-8fa6-9def0b938af7",
    "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fbanner_image%2F2.jpg?alt=media&token=aeaf4fbb-84cb-447b-a45c-719a66968e03",
    "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fbanner_image%2F3.jpg?alt=media&token=a47d9d90-cba0-4b10-98b7-d06eac0aee9a"
];
export const planIcons = {
    Municipal:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fbanner_icon%2F250_Municipal_Clearances.png?alt=media&token=92306a64-4ac5-461d-a072-2aa3a1c52087",
    Approved: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fbanner_icon%2F300_Approved_Projects.png?alt=media&token=b859a5e0-63af-4b65-8f9b-dbe8d868a96f",
    Compliance:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fbanner_icon%2F900_Compliance_Checks.png?alt=media&token=0b2251f7-bf10-41eb-829b-1b7dd47011ae"
};

export const OurExp = [
    "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FOur_expertise_image%2FDocument_and_Drawing_Verification.png?alt=media&token=429b8c49-208c-477d-93d0-d5189d0f59a1",
    "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FOur_expertise_image%2FLegal_and_Safety_Regulations.png?alt=media&token=56071cab-a442-429e-b72b-4253b9c2949c",
    "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FOur_expertise_image%2FMunicipal_and_Government_Compliance.png?alt=media&token=b0970e52-16d7-4f2a-a956-af540c16a2dc",
    "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FOur_expertise_image%2FResidential_and_Commercial_Plan_Approvals.png?alt=media&token=92a5e346-bb32-45cc-a18e-56837ce8bcc9"
];


export const ExecutionCities = [
    {
        city: "Bangalore",
        address: "",
        image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fexecution-cities%2Fbangalore.png?alt=media&token=77dc32c9-5309-47e9-80d9-cd09eaf39d28"
    },

    {
        city: "Kolkata",
        address: "",
        image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fexecution-cities%2Fkolkata.png?alt=media&token=e73bfaf4-5998-424a-acf2-5ac8a6af9273"
    },

    {
        city: "Hyderabad",
        address: "",
        image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fexecution-cities%2Fhyderabad.png?alt=media&token=49c575a0-0b11-4cfa-b0b5-a1405e8b7ec2"
    },
    {
        city: "Ranchi",
        address: "",
        image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fexecution-cities%2Franchi.png?alt=media&token=6e608005-fc79-415e-b4b8-7fad2506fc4c"
    },


    {
        city: "Chennai",
        address: "",
        image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fexecution-cities%2Fhyderabad.png?alt=media&token=49c575a0-0b11-4cfa-b0b5-a1405e8b7ec2"
    },

    {
        city: "Patna",
        address: "",
        image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fexecution-cities%2Fkolkata.png?alt=media&token=e73bfaf4-5998-424a-acf2-5ac8a6af9273"
    },


];




